import React from "react";

export const isDevMode = () => {
  return process.env.NODE_ENV === "development";
};

/**
 * 开发模式专用醒目文本 —— 带有滚动动画背景
 */
export const DevText = ({ children }) => {
  if (!isDevMode()) return null;
  if (!localStorage.getItem("debug")) return null;

  // 动画背景样式（滚动条纹 + 亮色警示）
  const animatedStyle = {
    display: "inline-block",
    padding: "2px 8px",
    borderRadius: "4px",
    fontWeight: "bold",
    color: "#111",
    backgroundImage:
      "repeating-linear-gradient(45deg, #ffd966 0px, #ffd966 10px, #ffb347 10px, #ffb347 20px)",
    backgroundSize: "200% 100%",
    animation: "devScroll 10s linear infinite",
    boxShadow: "0 0 6px #ffaa33",
  };

  return (
    <>
      {/* 将关键帧注入全局（仅一次） */}
      <style>
        {`
          @keyframes devScroll {
            0% { background-position: 0% 0%; }
            100% { background-position: 100% 0%; }
          }
        `}
      </style>
      <span style={animatedStyle}>🛠️ {children} 🛠️</span>
    </>
  );
};



// WEBPACK FOOTER //
// ./src/components/development/index.js